<template>
  <CToaster placement="top-end" class="p-2">
    <CToast v-if="submitted" :visible="true" delay="6000" color="success" :title="$t('api.nps.thank_you')">
      <CToastHeader close-button>
        <div class="me-auto">
          {{ $t('api.nps.thank_you') }}
        </div>
      </CToastHeader>
    </CToast>
  </CToaster>
  <CModal class="nps-survey-modal" alignment="center" backdrop="static" :visible="showModal" size="lg">
    <CModalBody class="px-0">
      <CRow>
        <CCol xs="12" class="text-center h4"> {{ $t('api.nps.title') }} </CCol>

        <CCol xs="12" class="text-center mt-3">
          <p class="d-none d-lg-inline fw-light">{{ $t('api.nps.unlikely') }}</p>
          <CRating
            v-model="surveyValues.nps"
            highlight-only-selected
            :item-count="11"
            class="mx-0 mx-lg-3 d-inline-flex mypg-nps-survey-rating"
          >
            <template #activeIcon="{ value }">
              <div class="text-primary">
                {{ value - 1 }}
              </div>
            </template>
            <template #icon="{ value }">
              <div>
                {{ value - 1 }}
              </div>
            </template>
          </CRating>
          <p class="d-none d-lg-inline fw-light">{{ $t('api.nps.likely') }}</p>
        </CCol>
        <CCol xs="12" class="d-flex d-lg-none justify-content-between px-sm-4">
          <p class="m-0 fw-lighter">
            {{ $t('api.nps.unlikely') }}
          </p>
          <p class="m-0 fw-lighter">
            {{ $t('api.nps.likely') }}
          </p>
        </CCol>

        <CCol xs="12" class="px-4 mt-4">
          <CFormTextarea
            v-model="surveyValues.comment"
            class="border-3"
            :placeholder="$t('api.nps.comment', { apxLabel, mpgLabel })"
            rows="3"
          />
        </CCol>
      </CRow>
    </CModalBody>
    <CModalFooter class="justify-content-between">
      <CButton color="secondary" @click="onReject">
        {{ $t('api.nps.not_now') }}
      </CButton>
      <CButton :disabled="surveyValues.nps === null" color="primary" @click="onSubmit">
        {{ $t('api.general.submit') }}
      </CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import { ref, onMounted } from 'vue'
import { rejectNpsSurvey, submitNpsSurvey } from '@/api/survey'

export default {
  name: 'NpsSurveyModal',
  components: {},
  setup() {
    const showModal = ref(false)

    const npsToggleBtn = document.getElementById('nps-toggle-btn')
    npsToggleBtn?.addEventListener('click', () => (showModal.value = true))

    const npsDisplayState = ref(npsToggleBtn ? npsToggleBtn.dataset.npsDisplayInitialState : 'UNKNOWN')
    if (npsDisplayState.value === 'POPUP') {
      onMounted(() => (showModal.value = true))
    }

    const submitted = ref(false)
    const surveyValues = ref({
      nps: null,
      comment: null
    })

    // NOTE: "legacy" JS has to be used, because target DOM is rendered by BE
    const showInfoTooltip = () => {
      const tooltip = global.coreui.Tooltip.getInstance(npsToggleBtn)
      if (!tooltip) return

      tooltip.show()
      setTimeout(() => tooltip.hide(), 10000)
    }
    const hideRemindBubble = () => {
      const el = document.querySelector('#nps-toggle-btn .rounded-circle')
      if (!el) return

      el.remove()
    }
    const hideSurveyNavItem = () => {
      const el = document.getElementById('nps-toggle-btn-container')
      if (!el) return

      el.remove()
    }
    const nextNpsDisplayState = () => {
      if (submitted.value) {
        hideSurveyNavItem()
        npsDisplayState.value = 'HIDE'

        return
      }

      switch (npsDisplayState.value) {
        case 'POPUP':
          showInfoTooltip()
          npsDisplayState.value = 'REMIND'
          return
        case 'REMIND':
          hideRemindBubble()
          npsDisplayState.value = 'DISPLAY'
          return
      }
    }

    return {
      apxLabel: document.getElementById('main').dataset.apxLabel,
      mpgLabel: document.getElementById('main').dataset.mpgLabel,
      onReject: () => {
        rejectNpsSurvey().finally(() => {
          showModal.value = false
          nextNpsDisplayState()
        })
      },
      onSubmit: () => {
        submitNpsSurvey({
          npsScore: surveyValues.value.nps - 1,
          comment: surveyValues.value.comment
        }).finally(() => {
          showModal.value = false
          submitted.value = true
          nextNpsDisplayState()
        })
      },
      showModal,
      submitted,
      surveyValues
    }
  }
}
</script>
